export default () => ({
  el: undefined,
  modalId: undefined,
  init() {
    mrp.log(`RxModalDialogTrigger init`);
    this.el = this.$el;
    this.modalId = this.el.getAttribute("data-modal-id");
  },
  trigger() {
    let modal = document.getElementById(this.modalId);
    modal.showModal();
  },
});
